import React from 'react'

export default function UniqueRoullete() {
  return (
   <div className="center-main-container casino-page">
  <div className="center-container">
    <div className="casino-page-container roulette">
      <div className="casino-header">
        <span className="casino-name">
          Unique Roulette
          <a className="ms-1">
            <small>Rules</small>
          </a>
        </span>
        <span className="casino-rid d-none d-xl-inline-block">
          <small>
            Round ID: <span>163250430205054</span>
          </small>
          <small className="ms-2">
            <span>Range: 25 to 1L</span>
          </small>
        </span>
        <span className="casino-rid d-xl-none">
          <small className="ms-2">
            <span>Range: 25 to 1L</span>
          </small>
        </span>
      </div>
      <div className="casino-title-header-mobile d-xl-none">
        <ul className="nav nav-tabs menu-tabs">
          <li className="nav-item">
            <div className="nav-link active">Game</div>
          </li>
          <li className="nav-item">
            <div className="nav-link">Placed Bet (0)</div>
          </li>
        </ul>
        <div className="pe-2">
          <span className="casino-rid">
            Round ID: <span>163250430205054</span>
          </span>
        </div>
      </div>
      <div className="">
        <div className="casino-video full">
          <div className="video-box-container">
            <div className="casino-video-box">
              {/* <iframe src="/mediaplayer/ourroullete/d58ad7fa-8a63-478d-b885-f73ceefa5845?ip=122.160.119.41" /> */}
            </div>
          </div>
          <div className="casino-video-cards">
            <div>
              <div className="flip-card-container">
                <div className="flip-card">
                  <div className="flip-card-inner">
                    <div className="flip-card-front">
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/roulette/17.png" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="clock flip-clock-wrapper">
            <ul className="flip play">
              <li className="flip-clock-before">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">1</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">1</div>
                  </div>
                </a>
              </li>
              <li className="flip-clock-active">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">0</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">0</div>
                  </div>
                </a>
              </li>
            </ul>
            <ul className="flip play">
              <li className="flip-clock-before">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">1</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">1</div>
                  </div>
                </a>
              </li>
              <li className="flip-clock-active">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">0</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">0</div>
                  </div>
                </a>
              </li>
            </ul>
          </div> */}
        </div>
        <div className="casino-detail">
          <div className="casino-table">
            <div className="roulette-box-container">
              <div className="board-in">
                <div className="board-right">
                  <div className="board-cell yellow suspended-box">
                    <div className="board-cell-in">
                      <span className="board-text">2to1</span>
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={138}
                      />
                    </div>
                  </div>
                  <div className="board-cell yellow suspended-box">
                    <div className="board-cell-in">
                      <span className="board-text">2to1</span>
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={137}
                      />
                    </div>
                  </div>
                  <div className="board-cell yellow suspended-box">
                    <div className="board-cell-in">
                      <span className="board-text">2to1</span>
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={136}
                      />
                    </div>
                  </div>
                </div>
                <div className="board-bottom">
                  <div className="board-cell yellow suspended-box">
                    <div className="board-cell-in">
                      <span className="board-text">1st12</span>
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={133}
                      />
                    </div>
                  </div>
                  <div className="board-cell yellow suspended-box">
                    <div className="board-cell-in">
                      <span className="board-text">2nd12</span>
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={134}
                      />
                    </div>
                  </div>
                  <div className="board-cell yellow suspended-box">
                    <div className="board-cell-in">
                      <span className="board-text">3rd12</span>
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={135}
                      />
                    </div>
                  </div>
                  <div className="board-cell yellow suspended-box">
                    <div className="board-cell-in">
                      <span className="board-text">1 - 18</span>
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={139}
                      />
                    </div>
                  </div>
                  <div className="board-cell yellow suspended-box">
                    <div className="board-cell-in">
                      <span className="board-text">Even</span>
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={144}
                      />
                    </div>
                  </div>
                  <div className="board-cell yellow suspended-box">
                    <div className="board-cell-in">
                      <span className="board-text">Red</span>
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={141}
                      />
                    </div>
                  </div>
                  <div className="board-cell yellow suspended-box">
                    <div className="board-cell-in">
                      <span className="board-text">Black</span>
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={142}
                      />
                    </div>
                  </div>
                  <div className="board-cell yellow suspended-box">
                    <div className="board-cell-in">
                      <span className="board-text">Odd</span>
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={143}
                      />
                    </div>
                  </div>
                  <div className="board-cell yellow suspended-box">
                    <div className="board-cell-in">
                      <span className="board-text">19 - 36</span>
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={140}
                      />
                    </div>
                  </div>
                </div>
                <div className="board-center">
                  <div className="board-cell green suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">0</span>
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={1}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">1</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={38}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={2}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={110}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={74}
                      />
                    </div>
                  </div>
                  <div className="board-cell black suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">2</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={39}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={3}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={145}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={75}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">3</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={40}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={4}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={146}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={98}
                      />
                    </div>
                  </div>
                  <div className="board-cell black suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">4</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={41}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={5}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={76}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">5</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={52}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={6}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={111}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={77}
                      />
                    </div>
                  </div>
                  <div className="board-cell black suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">6</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={63}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={7}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={112}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={99}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">7</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={42}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={8}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={78}
                      />
                    </div>
                  </div>
                  <div className="board-cell black suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">8</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={53}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={9}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={113}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={79}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">9</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={64}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={10}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={114}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={100}
                      />
                    </div>
                  </div>
                  <div className="board-cell black suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">10</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={43}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={11}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={80}
                      />
                    </div>
                  </div>
                  <div className="board-cell black suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">11</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={54}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={12}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={115}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={81}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">12</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={65}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={13}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={116}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={101}
                      />
                    </div>
                  </div>
                  <div className="board-cell black suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">13</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={44}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={14}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={82}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">14</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={55}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={15}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={117}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={83}
                      />
                    </div>
                  </div>
                  <div className="board-cell black suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">15</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={66}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={16}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={118}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={102}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">16</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={45}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={17}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={84}
                      />
                    </div>
                  </div>
                  <div className="board-cell black">
                    <div className="board-cell-in">
                      <span className="board-number pop-outin">17</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={56}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={18}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={119}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={85}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">18</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={67}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={19}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={120}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={103}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">19</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={46}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={20}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={86}
                      />
                    </div>
                  </div>
                  <div className="board-cell black suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">20</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={57}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={21}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={121}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={87}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">21</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={68}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={22}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={122}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={104}
                      />
                    </div>
                  </div>
                  <div className="board-cell black suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">22</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={47}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={23}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={88}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">23</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={58}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={24}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={123}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={89}
                      />
                    </div>
                  </div>
                  <div className="board-cell black suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">24</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={69}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={25}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={124}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={105}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">25</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={48}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={26}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={90}
                      />
                    </div>
                  </div>
                  <div className="board-cell black suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">26</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={59}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={27}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={125}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={91}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">27</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={70}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={28}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={126}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={106}
                      />
                    </div>
                  </div>
                  <div className="board-cell black suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">28</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={49}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={29}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={92}
                      />
                    </div>
                  </div>
                  <div className="board-cell black suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">29</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={60}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={30}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={127}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={93}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">30</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={71}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={31}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={128}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={107}
                      />
                    </div>
                  </div>
                  <div className="board-cell black suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">31</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={50}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={32}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={94}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">32</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={61}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={33}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={129}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={95}
                      />
                    </div>
                  </div>
                  <div className="board-cell black suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">33</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={72}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={34}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={130}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={108}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">34</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={51}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={35}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={96}
                      />
                    </div>
                  </div>
                  <div className="board-cell black suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">35</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={62}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={36}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={131}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={97}
                      />
                    </div>
                  </div>
                  <div className="board-cell red suspended-box">
                    <div className="board-cell-in">
                      <span className="board-number">36</span>
                      <div
                        className="bet-chip-area center-left coin-place"
                        id={73}
                      />
                      <div
                        className="bet-chip-area center-center coin-place"
                        id={37}
                      />
                      <div
                        className="bet-chip-area bottom-left coin-place"
                        id={132}
                      />
                      <div
                        className="bet-chip-area top-center coin-place"
                        id={109}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="casino-last-result-title">
            <span>Last Result</span>
            <span>
              <a href="/casino-results/ourroullete">View All</a>
            </span>
          </div>
          <div className="casino-last-results">
            <span className="result red">32</span>
            <span className="result red">34</span>
            <span className="result black">20</span>
            <span className="result black">29</span>
            <span className="result black">08</span>
            <span className="result black">11</span>
            <span className="result red">19</span>
            <span className="result black">10</span>
            <span className="result black">04</span>
            <span className="result black">15</span>
          </div>
          <div className="sidebar-box my-bet-container roulette-rules mt-2 d-xl-none">
            <div className="table-responsive ">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">Single</th>
                    <th className="text-center">Split</th>
                    <th className="text-center">Street</th>
                    <th className="text-center">Corner</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-center">
                      <b>0</b>
                    </td>
                    <td className="text-center">
                      <b>0</b>
                    </td>
                    <td className="text-center">
                      <b>0</b>
                    </td>
                    <td className="text-center">
                      <b>0</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
    </div>
  </div>
  <div className="sidebar right-sidebar casino-right-sidebar sticky">
    <div className="sidebar-box my-bet-container">
      <div className="sidebar-title">
        <h4>My Bet</h4>
      </div>
      <div className="my-bets">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
    </div>
    <div className="sidebar-box my-bet-container roulette-rules">
      <div className="sidebar-title">
        <h4>Rates</h4>
      </div>
      <div className="">
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th className="text-center">Single</th>
                <th className="text-center">Split</th>
                <th className="text-center">Street</th>
                <th className="text-center">Corner</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-center">
                  <b>0</b>
                </td>
                <td className="text-center">
                  <b>0</b>
                </td>
                <td className="text-center">
                  <b>0</b>
                </td>
                <td className="text-center">
                  <b>0</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

  )
}
